<template>
  <component
    :is="name"
    v-bind="$props"
    class="cxm-Icon"
    :class="{ '-pointer': handleClick }"
    @click.native="clickMethod"
  />
</template>

<script>
export default {
  name: 'IconBase',
  components: {
    Airplay: () => import('./Icons/Airplay.vue'),
    Alert: () => import('./Icons/Alert.vue'),
    AlignCenter: () => import('./Icons/AlignCenter.vue'),
    AlignLeft: () => import('./Icons/AlignLeft.vue'),
    AlignRight: () => import('./Icons/AlignRight.vue'),
    Annotation: () => import('./Icons/Annotation.vue'),
    Anonymous: () => import('./Icons/Anonymous.vue'),
    ArrowDown: () => import('./Icons/ArrowDown.vue'),
    ArrowIconMenu: () => import('./Icons/ArrowIconMenu.vue'),
    ArrowIconMenuClose: () => import('./Icons/ArrowIconMenuClose.vue'),
    ArrowLeft: () => import('./Icons/ArrowLeft.vue'),
    ArrowRight: () => import('./Icons/ArrowRight.vue'),
    ArrowUp: () => import('./Icons/ArrowUp.vue'),
    Bar: () => import('./Icons/Bar.vue'),
    Block: () => import('./Icons/Block.vue'),
    Briefcase: () => import('./Icons/Briefcase.vue'),
    Calendar: () => import('./Icons/Calendar.vue'),
    Cancel: () => import('./Icons/Cancel.vue'),
    Chat: () => import('./Icons/Chat.vue'),
    Check: () => import('./Icons/Check.vue'),
    CheckOutlined: () => import('./Icons/CheckOutlined.vue'),
    ChevronDown: () => import('./Icons/ChevronDown.vue'),
    ChevronDownDouble: () => import('./Icons/ChevronDownDouble.vue'),
    ChevronLeft: () => import('./Icons/ChevronLeft.vue'),
    ChevronLeftDouble: () => import('./Icons/ChevronLeftDouble.vue'),
    ChevronRight: () => import('./Icons/ChevronRight.vue'),
    ChevronRightDouble: () => import('./Icons/ChevronRightDouble.vue'),
    ChevronUp: () => import('./Icons/ChevronUp.vue'),
    ChevronUpDouble: () => import('./Icons/ChevronUpDouble.vue'),
    Client: () => import('./Icons/Client.vue'),
    Clock: () => import('./Icons/Clock.vue'),
    Close: () => import('./Icons/Close.vue'),
    Complete: () => import('./Icons/Complete.vue'),
    Copy: () => import('./Icons/Copy.vue'),
    Csat: () => import('./Icons/Csat.vue'),
    CustomerIcon: () => import('./Icons/CustomerIcon.vue'),
    Dots: () => import('./Icons/Dots.vue'),
    DashboardIcon: () => import('./Icons/DashboardIcon.vue'),
    Document: () => import('./Icons/Document.vue'),
    Download: () => import('./Icons/Download.vue'),
    DropDown: () => import('./Icons/DropDown.vue'),
    Edit: () => import('./Icons/Edit.vue'),
    Email: () => import('./Icons/Email.vue'),
    EmptyNote: () => import('./Icons/EmptyNote.vue'),
    Error: () => import('./Icons/Error.vue'),
    Eye: () => import('./Icons/Eye.vue'),
    EyeClose: () => import('./Icons/EyeClose.vue'),
    Filters: () => import('./Icons/Filters.vue'),
    Grid: () => import('./Icons/Grid.vue'),
    Happy: () => import('./Icons/Happy.vue'),
    HappySolid: () => import('./Icons/HappySolid.vue'),
    Hourglass: () => import('./Icons/Hourglass.vue'),
    HourglassIcon: () => import('./Icons/HourglassIcon.vue'),
    IconAdd: () => import('./Icons/IconAdd.vue'),
    ImageIcon: () => import('./Icons/ImageIcon.vue'),
    Info: () => import('./Icons/Info.vue'),
    Interaction: () => import('./Icons/Interaction.vue'),
    InteractionsIcon: () => import('./Icons/InteractionsIcon.vue'),
    Like: () => import('./Icons/Like.vue'),
    LikeSolid: () => import('./Icons/LikeSolid.vue'),
    Link: () => import('./Icons/Link.vue'),
    LinkSms: () => import('./Icons/LinkSms.vue'),
    LinkWhatsapp: () => import('./Icons/LinkWhatsapp.vue'),
    List: () => import('./Icons/List.vue'),
    Loading: () => import('./Icons/Loading.vue'),
    Loop: () => import('./Icons/Loop.vue'),
    LoopIcon: () => import('./Icons/LoopIcon.vue'),
    Map: () => import('./Icons/Map.vue'),
    Message: () => import('./Icons/Message.vue'),
    Metric: () => import('./Icons/Metric.vue'),
    MultipleChoice: () => import('./Icons/MultipleChoice.vue'),
    NewChevronUp: () => import('./Icons/NewChevronUp.vue'),
    NewChevronDown: () => import('./Icons/NewChevronDown.vue'),
    NewError: () => import('./Icons/NewError.vue'),
    NoResults: () => import('./Icons/noResults.vue'),
    Normal: () => import('./Icons/Normal.vue'),
    Nps: () => import('./Icons/Nps.vue'),
    Opinion: () => import('./Icons/Opinion.vue'),
    OverviewIcon: () => import('./Icons/OverviewIcon.vue'),
    Phone: () => import('./Icons/Phone.vue'),
    QRCode: () => import('./Icons/QRCode.vue'),
    Queue: () => import('./Icons/Queue.vue'),
    Remove: () => import('./Icons/Remove.vue'),
    Report: () => import('./Icons/Report.vue'),
    Refresh: () => import('./Icons/Refresh.vue'),
    Sad: () => import('./Icons/Sad.vue'),
    Search: () => import('./Icons/Search.vue'),
    Send: () => import('./Icons/Send.vue'),
    Settings: () => import('./Icons/Settings.vue'),
    SettingsIcon: () => import('./Icons/SettingsIcon.vue'),
    Sms: () => import('./Icons/Sms.vue'),
    Speedometer: () => import('./Icons/Speedometer.vue'),
    Star: () => import('./Icons/Star.vue'),
    StarSolid: () => import('./Icons/StarSolid.vue'),
    Success: () => import('./Icons/Success.vue'),
    SurveyIcon: () => import('./Icons/SurveyIcon.vue'),
    TableEdit: () => import('./Icons/TableEdit.vue'),
    Tag: () => import('./Icons/Tag.vue'),
    TextIcon: () => import('./Icons/TextIcon.vue'),
    ThumbsDown: () => import('./Icons/ThumbsDown.vue'),
    ThumbsUp: () => import('./Icons/ThumbsUp.vue'),
    Trash: () => import('./Icons/Trash.vue'),
    Upload: () => import('./Icons/Upload.vue'),
    Unlock: () => import('./Icons/Unlock.vue'),
    VeryHappy: () => import('./Icons/VeryHappy.vue'),
    VerySad: () => import('./Icons/VerySad.vue'),
    Warning: () => import('./Icons/Warning.vue'),
    WarningOutlined: () => import('./Icons/WarningOutlined.vue'),
    Web: () => import('./Icons/Web.vue'),
    Whatsapp: () => import('./Icons/Whatsapp.vue'),
    Widget: () => import('./Icons/Widget.vue'),
    Without: () => import('./Icons/Without.vue'),
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: [String, Number],
      default: 24,
    },
    color: {
      type: String,
      default: 'var(--track-color-bluegray-80)',
    },
    colorHover: {
      type: String,
      default: 'var(--track-color-bluegray-80)',
    },
    handleClick: {
      type: Function,
      default: null,
    },
    stopPropagation: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    clickMethod(event) {
      if (this.stopPropagation) {
        event.stopPropagation();
      }
      if (this.handleClick) {
        this.handleClick();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cxm-Icon {
  &.-pointer {
    cursor: pointer;
  }
}
</style>
